export const EsocialPessoaTipoEnum = Object.freeze({
    CNPJ: 1,
    CPF: 2
});

export const EsocialPessoaTipoEnumLabel = new Map([
    [EsocialPessoaTipoEnum.CNPJ, 'CNPJ'],
    [EsocialPessoaTipoEnum.CPF, 'CPF']
]);
